var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { Row } from '@amzn/atoz-web/Row';
import { Text } from '@amzn/atoz-web/Text';
import { View } from '@amzn/atoz-web/View';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { EstimatedPaidHours } from './EstimatedPaidHours';
import { useShiftInfoData } from './utils';
export var ShiftInfo = function (_a) {
    var shift = _a.shift, skills = _a.skills, payBreakdown = _a.payBreakdown;
    var _b = useShiftInfoData({ shift: shift, skills: skills, payBreakdown: payBreakdown }), timeRangeStr = _b.timeRangeStr, durationStr = _b.durationStr, paidDurationStr = _b.paidDurationStr, siteStr = _b.siteStr, skillsStr = _b.skillsStr;
    return (React.createElement(Container, { dataTestId: "ShiftInfo" },
        React.createElement(Row, { margin: { bottom: 'S200' } },
            React.createElement(Text, { fontSize: "T300", role: "heading", "aria-level": 3 },
                React.createElement("strong", null, timeRangeStr),
                " (",
                durationStr,
                ")")),
        paidDurationStr && (React.createElement(Row, { margin: { bottom: 'S200' } },
            React.createElement(EstimatedPaidHours, { paidDuration: paidDurationStr }))),
        siteStr && (React.createElement(Row, null,
            React.createElement(Text, { dataTestId: "ShiftInfo-site", fontSize: "T200" }, siteStr))),
        skillsStr && (React.createElement(Row, null,
            React.createElement(Text, { dataTestId: "ShiftInfo-skill", fontSize: "T200" }, skillsStr)))));
};
var Container = styledWithTheme(View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var templateObject_1;
